import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-sub-add.png'


const _withScopeId = n => (_pushScopeId("data-v-d30fc5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "resource-box" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM, BOARD_TYPE, BOARD_VIDEO_TYPE } from '@/common'
import {
  queryBoardVideoList,
  addBoardInfo,
  updateBoardInfo,
  queryBoardReportList,
  queryBoardDeviceMetadataList,
} from '@/api'
import { useDeviceStore } from '@/stores/device'
import { isEmpty } from 'lodash'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'component-form-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t

const deviceStore = useDeviceStore()

deviceStore.queryDeviceOps()




watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryDetail()
    }
  }
)

// 编辑恢复数据
const queryDetail = () => {
  const { id, name, type, dataConfig } = props.data
  if (!id) {
    return
  }
  const config = JSON.parse(dataConfig)
  if (type === BOARD_TYPE.VIDEO) {
    formData.value = {
      ...formData.value,
      videoId: config.id,
      videoType: config.type,
    }
  } else if (type === BOARD_TYPE.STATISTICS) {
    formData.value = {
      ...formData.value,
      reportId: Number(config.id),
      type,
    }
  } else if (type === BOARD_TYPE.LOCATION) {
    formData.value = {
      ...formData.value,
      location: config,
    }
  } else {
    const deviceList = config.map((item: any) => {
      const { gatewayDeviceId, subDeviceId, code } = item
      return {
        id: gatewayDeviceId,
        code: subDeviceId + '-' + code,
      }
    })
    formData.value = {
      ...formData.value,
      deviceList,
    }

    deviceList.map(({ id }: any) => {
      onDeviceChange(id)
    })
  }

  formData.value = {
    ...formData.value,
    name,
    type,
  }
}

const typeOps = [
  {
    label: t('STATISTICS.bftext'),
    value: BOARD_TYPE.TEXT,
  },
  {
    label: t('STATISTICS.bfinstrument'),
    value: BOARD_TYPE.INSTRUMENT,
  },
  {
    label: t('STATISTICS.bfvideo'),
    value: BOARD_TYPE.VIDEO,
  },
  {
    label: t('STATISTICS.bflocation'),
    value: BOARD_TYPE.LOCATION,
  },
  {
    label: t('STATISTICS.bfstatistics'),
    value: BOARD_TYPE.STATISTICS,
  },
]

const formData = ref({
  name: '',
  type: '',
  videoType: '',
  videoId: '',
  reportId: '',
  location: [
    {
      id: '',
    },
  ],
  deviceList: [
    {
      id: '',
      code: '',
    },
  ],
  locationCode: 'code',
})

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
  formData.value = {
    name: '',
    type: '',
    videoType: '',
    videoId: '',
    reportId: '',
    location: [
      {
        id: '',
      },
    ],
    deviceList: [
      {
        id: '',
        code: '',
      },
    ],
    locationCode: 'code',
  }
}

const dataConfvalidator = (rule: any, value: any, callback: any) => {
  const { type, location, deviceList } = formData.value
  if (type === BOARD_TYPE.LOCATION && location.length === 0) {
    callback(t('STATISTICS.bfdataConfMsg'))
    return
  }
  if (
    [BOARD_TYPE.INSTRUMENT, BOARD_TYPE.TEXT].includes(type) &&
    deviceList.length === 0
  ) {
    callback(t('STATISTICS.bfdataConfMsg'))
    return
  }
  callback()
}

const locationvalidator = (rule: any, value: any, callback: any) => {
  const idList = formData.value.location.filter((item) => {
    return value === item.id
  })
  if (idList.length > 1) {
    callback(t('STATISTICS.bfdeviceReMsg'))
  } else {
    callback()
  }
}

const rules: any = {
  name: [{ required: true, message: t('STATISTICS.bfenter') }],
  type: [{ required: true, message: t('STATISTICS.bfselect') }],
  videoType: [{ required: true, message: t('STATISTICS.bfselect') }],
  videoId: [{ required: true, message: t('STATISTICS.bfselect') }],
  reportId: [{ required: true, message: t('STATISTICS.bfselect') }],
  dataConfig: [{ validator: dataConfvalidator }],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()
const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const fn = props.data?.id ? updateBoardInfo : addBoardInfo

      loading.value = true
      const res: any = await fn({
        ...dealwithData(),
        id: props.data?.id,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: res?.msg,
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

// 处理数据
const dealwithData = () => {
  const { name, type, videoId, videoType, reportId, location, deviceList } =
    formData.value
  let dataConfig = {}
  if (type === BOARD_TYPE.VIDEO) {
    dataConfig = {
      id: videoId,
      type: videoType,
    }
  } else if (type === BOARD_TYPE.STATISTICS) {
    dataConfig = {
      id: reportId,
    }
  } else if (type === BOARD_TYPE.LOCATION) {
    dataConfig = location
  } else {
    dataConfig = deviceList.map((item) => {
      const { id, code } = item
      const [subDeviceId, attrCode] = code.split('-')
      return {
        gatewayDeviceId: id,
        subDeviceId,
        code: attrCode,
      }
    })
  }

  return {
    name,
    type,
    dataConfig: JSON.stringify(dataConfig),
  }
}

const videoType = [
  {
    label: t('STATISTICS.bfstream'),
    value: BOARD_VIDEO_TYPE.STREAMING,
  },
]

const videoList = ref([])
const queryVideoList = async () => {
  const res: any = await queryBoardVideoList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    videoList.value = res.data || []
  }
}
queryVideoList()

const reportList: any = ref([])
const queryReportList = async () => {
  const res: any = await queryBoardReportList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    reportList.value = res.data || []
  }
}
queryReportList()

const locationList = [
  {
    label: t('STATISTICS.bflatlng'),
    value: 'code',
  },
]

const removeLocation = (index: number) => {
  formData.value.location = formData.value.location.filter(
    (item: any, i) => i !== index
  )
}

const addLocation = () => {
  formData.value.location.push({ id: '' })
}

const removeDeviceList = (index: number) => {
  formData.value.deviceList = formData.value.deviceList.filter(
    (item: any, i) => i !== index
  )
}

const addDeviceList = () => {
  formData.value.deviceList.push({ id: '' })
}

const deviceCodeMap = ref({})

const getCodeOps = (gatewayDeviceId: string) => {
  return deviceCodeMap.value[gatewayDeviceId] || []
}

const onDeviceChange = async (gatewayDeviceId: string, index?: number) => {
  if (index !== undefined) {
    formData.value.deviceList[index].code = ''
  }
  if (!isEmpty(deviceCodeMap[gatewayDeviceId])) {
    return
  }
  const res: any = await queryBoardDeviceMetadataList({ gatewayDeviceId })
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceCodeMap.value[gatewayDeviceId] = (res.data || []).map((item: any) => {
      const { name, code, deviceId } = item
      return {
        label: name,
        value: deviceId + '-' + code,
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: 
      props.data.id ? _ctx.$t('STATISTICS.bfeditTitle') : _ctx.$t('STATISTICS.bfnewTitle')
    ,
    size: "480px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.rfYes')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.rfNo')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "98"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "name",
              label: _ctx.$t('STATISTICS.bfname')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  maxlength: "20",
                  placeholder: _ctx.$t('STATISTICS.bfnamePla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "type",
              label: _ctx.$t('STATISTICS.bfType')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "ws_select_form",
                  modelValue: formData.value.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event)),
                  placeholder: _ctx.$t('STATISTICS.bfTypePla')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOps, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (formData.value.type)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "dataConfig",
                  label: _ctx.$t('STATISTICS.bfdataConfig'),
                  "label-width": "320",
                  class: "resource"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (formData.value.type === _unref(BOARD_TYPE).VIDEO)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            gutter: 10
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 11 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "videoType",
                                    label: _ctx.$t('STATISTICS.bfvideoType')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "ws_select_form",
                                        modelValue: formData.value.videoType,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.videoType) = $event)),
                                        placeholder: _ctx.$t('STATISTICS.bfvideoTypePla')
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(videoType, (item) => {
                                            return _createVNode(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"])
                                          }), 64))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "placeholder"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 13 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "videoId",
                                    "label-width": 1
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "ws_select_form",
                                        modelValue: formData.value.videoId,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.videoId) = $event)),
                                        placeholder: _ctx.$t('STATISTICS.bfvideoIdPla')
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.id,
                                              label: item.name,
                                              value: item.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (formData.value.type === _unref(BOARD_TYPE).LOCATION)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.location, (domain, index) => {
                              return (_openBlock(), _createBlock(_component_el_row, {
                                gutter: 5,
                                key: index,
                                class: "ws_mb20"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 14 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: 'location.' + index + '.id',
                                        rules: [
                      {
                        required: true,
                        message: _ctx.$t('STATISTICS.bflocationIdPla'),
                        trigger: 'change',
                      },
                      {
                        validator: locationvalidator,
                      },
                    ],
                                        label: 
                      _ctx.$t('STATISTICS.bflocationId', { text: Number(index + 1) })
                    
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: "ws_select_form",
                                            modelValue: domain.id,
                                            "onUpdate:modelValue": ($event: any) => ((domain.id) = $event),
                                            placeholder: _ctx.$t('STATISTICS.bfdevicePla')
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceStore).deviceOps, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop", "rules", "label"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, { span: 9 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "locationCode",
                                        "label-width": 1,
                                        required: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            disabled: "",
                                            class: "ws_select_form",
                                            modelValue: formData.value.locationCode,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.locationCode) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locationList, (item) => {
                                                return _createVNode(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"])
                                              }), 64))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, {
                                        onClick: ($event: any) => (removeLocation(index)),
                                        class: "icon"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete, { color: "#409EFF" })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            (formData.value.location.length < 20)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  onClick: addLocation,
                                  type: "text",
                                  class: "ws_ml8"
                                }, {
                                  icon: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('STATISTICS.bfadd')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (
                [_unref(BOARD_TYPE).TEXT, _unref(BOARD_TYPE).INSTRUMENT].includes(formData.value.type)
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.deviceList, (domain, index) => {
                              return (_openBlock(), _createBlock(_component_el_row, {
                                gutter: 5,
                                key: index,
                                class: "ws_mb20"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 14 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: 'deviceList.' + index + '.id',
                                        rules: {
                      required: true,
                      message: _ctx.$t('STATISTICS.bfselect'),
                      trigger: 'change',
                    },
                                        label: 
                      _ctx.$t('STATISTICS.bflocationId', { text: Number(index + 1) })
                    
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: "ws_select_form",
                                            modelValue: domain.id,
                                            "onUpdate:modelValue": ($event: any) => ((domain.id) = $event),
                                            placeholder: _ctx.$t('STATISTICS.bfdevicePla'),
                                            onChange: (e) => onDeviceChange(e, index)
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceStore).deviceOps, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop", "rules", "label"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, { span: 9 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: 'deviceList.' + index + '.code',
                                        rules: {
                      required: true,
                      message: _ctx.$t('STATISTICS.bfselect'),
                      trigger: 'change',
                    },
                                        "label-width": 1
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: "ws_select_form",
                                            modelValue: domain.code,
                                            "onUpdate:modelValue": ($event: any) => ((domain.code) = $event),
                                            placeholder: _ctx.$t('STATISTICS.bfcodesetPla')
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCodeOps(domain.id), (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop", "rules"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, { span: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, {
                                        onClick: ($event: any) => (removeDeviceList(index)),
                                        class: "icon"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete, { color: "#409EFF" })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            (formData.value.deviceList.length < 2)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  onClick: addDeviceList,
                                  type: "text",
                                  class: "ws_ml8"
                                }, {
                                  icon: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('STATISTICS.bfadd')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (formData.value.type === _unref(BOARD_TYPE).STATISTICS)
                        ? (_openBlock(), _createBlock(_component_el_row, { key: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "reportId",
                                    label: _ctx.$t('STATISTICS.bfreport')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "ws_select_form",
                                        modelValue: formData.value.reportId,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.reportId) = $event)),
                                        placeholder: _ctx.$t('STATISTICS.bfreportPla')
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportList.value, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.id,
                                              label: item.reportName,
                                              value: item.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "placeholder"])
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})